<template>
  <div>
    <b-navbar toggleable="md" type="light" variant="light">

      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-navbar-brand>
        <div class="nav-header mr-4">
          <div class="logo">
            <img src="./../../../img/logo.svg">
          </div>
          <div class="sub-header mt-1">
            Affiliate Kontrollpanel
          </div>
        </div>
      </b-navbar-brand>

      <b-collapse is-nav id="navCollapse">

        <b-navbar-nav>

          <b-nav-item :to="{name: 'statistics'}">
            <font-awesome-icon icon="chart-line" />
            Statistik
          </b-nav-item>

          <b-nav-item :to="{name: 'orders'}" v-if="affiliate.earnings_mode === 'order'">
            <font-awesome-icon icon="shopping-cart" />
            Ordrar
          </b-nav-item>

          <b-nav-item :to="{name: 'searches'}" v-if="affiliate.earnings_mode === 'search'">
            <font-awesome-icon icon="search" />
            Sökningar
          </b-nav-item>

          <b-nav-item :to="{name: 'settings'}">
            <font-awesome-icon icon="cog" />
            Inställningar
          </b-nav-item>

          <b-nav-item :to="{name: 'earnings'}">
            <font-awesome-icon icon="coins" />
            Ersättning/fakturor
          </b-nav-item>

          <b-nav-item :to="{name: 'documentation'}">
            <font-awesome-icon icon="file" />
            Dokumentation
          </b-nav-item>

        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">

          <b-nav-item-dropdown right>
            <template slot="button-content">
              <span>
                <font-awesome-icon icon="user-alt" />
                {{ affiliate.name }}
              </span>
            </template>
            <b-dropdown-item @click="logout">
              Logga ut
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>

    <router-view></router-view>

    <footer class="text-center mt-5 pt-2 mb-3">
      <div class="text-muted">
        <small>
          &copy; TecknaEl, 2019
        </small>
      </div>
    </footer>

  </div>
</template>

<script>

  import {mapState} from 'vuex'

  export default {
    name: "Dashboard",
    computed: {
      ...mapState({
        affiliate: state => state.auth.affiliate,
      })
    },
    mounted(){
      if(this.$router.currentRoute.name === 'dashboard'){
        this.$router.push({name: 'statistics'})
      }
    },
    methods: {
      logout(){
        this.$store.commit('auth/erase')

        this.$cookies.remove('authToken');

        this.$router.push({name: 'login'});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Index.vue